export const BookmarkHeartIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 7.812a2.1 2.1 0 0 0-.773-.585 2.4 2.4 0 0 0-1.02-.215q-.895 0-1.543.649a2.11 2.11 0 0 0-.647 1.546q0 .474.135.874.134.4.56.944.362.488 1.003 1.117.64.63 1.656 1.574a.7.7 0 0 0 .304.18 1.25 1.25 0 0 0 .65 0 .7.7 0 0 0 .302-.18 58 58 0 0 0 1.64-1.551q.635-.63.995-1.115.425-.55.572-.963t.147-.885q0-.895-.647-1.543a2.1 2.1 0 0 0-1.543-.647q-.53 0-1.01.216a2.1 2.1 0 0 0-.782.584m0 10.356-4.77 2.04q-.85.366-1.616-.138-.764-.505-.764-1.429V4.43q0-.693.506-1.201a1.63 1.63 0 0 1 1.197-.509h10.892q.693 0 1.201.509.51.51.509 1.2v14.213q0 .924-.768 1.429-.768.504-1.62.137zm0-1.823 5.445 2.296V4.43H6.553V18.64zM12 4.43H6.552h10.892z"
      />
    </svg>
  );
};
